function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29",
  transform: "translate(-1095 -2653)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 23",
  cx: 40,
  cy: 40,
  r: 40,
  transform: "translate(1095 2653)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-business-center",
  d: "M1131.686 2699.751v-1.688h-11.582l-.017 6.751a3.334 3.334 0 003.314 3.376h23.2a3.334 3.334 0 003.314-3.376v-6.751h-11.6v1.688zm16.57-15.191h-6.644v-3.375l-3.314-3.376h-6.628l-3.314 3.376v3.376h-6.612a3.355 3.355 0 00-3.314 3.375V2693a3.334 3.334 0 003.314 3.376h9.942V2693h6.628v3.376h9.942a3.355 3.355 0 003.314-3.376v-5.064a3.355 3.355 0 00-3.313-3.376zm-9.942 0h-6.628v-3.375h6.628z",
  fill: "#f9cec8"
}));
var SvgSuitcase = function SvgSuitcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80"
  }, props), _ref);
};
export default SvgSuitcase;